// import { useEffect, useState } from "react";
// import axios from "axios";
// import Sidebar from './Sidebar';

// export default function CarManagement() {
//     const [cars, setCars] = useState([]);
//     const [manufacturers, setManufacturers] = useState([]);
//     const [newCar, setNewCar] = useState({
//         name: "",
//         manufacturerId: "",
//         type: "",
//         capacity: "",
//         perDay: "",
//         isPopular: false,
//         isRecommended: false,
//         travelType: "",
//         vehicleType: "",
//         isBooked: false,
//         image: null
//     });
//     const [showForm, setShowForm] = useState(false);

//     useEffect(() => {
//         fetchCars();
//         fetchManufacturers();
//     }, []);

//     const fetchCars = async () => {
//         try {
//             const response = await axios.get("https://carrentalbackend.dockyardsoftware.com/api/CarDetail");
//             setCars(response.data);
//         } catch (error) {
//             console.error("Error fetching cars:", error);
//         }
//     };

//     const fetchManufacturers = async () => {
//         try {
//             const response = await axios.get("https://carrentalbackend.dockyardsoftware.com/api/Manufacturer");
//             setManufacturers(response.data);
//         } catch (error) {
//             console.error("Error fetching manufacturers:", error);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, type, value, checked, files } = e.target;
//         if (type === "file") {
//             setNewCar(prevState => ({ ...prevState, image: files[0] }));
//         } else {
//             setNewCar(prevState => ({ ...prevState, [name]: type === "checkbox" ? checked : value }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!newCar.image) {
//             alert("Please select an image.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("name", newCar.name);
//         formData.append("manufacturerId", newCar.manufacturerId);
//         formData.append("type", newCar.type);
//         formData.append("capacity", newCar.capacity);
//         formData.append("perDay", newCar.perDay);
//         formData.append("isPopular", newCar.isPopular);
//         formData.append("isRecommended", newCar.isRecommended);
//         formData.append("travelType", newCar.travelType);
//         formData.append("vehicleType", newCar.vehicleType);
//         formData.append("isBooked", newCar.isBooked);
//         formData.append("imageFile", newCar.image);

//         try {
//             await axios.post("https://carrentalbackend.dockyardsoftware.com/api/CarDetail", formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             setNewCar({
//                 name: "",
//                 manufacturerId: "",
//                 type: "",
//                 capacity: "",
//                 perDay: "",
//                 isPopular: false,
//                 isRecommended: false,
//                 travelType: "",
//                 vehicleType: "",
//                 isBooked: false,
//                 image: null
//             });
//             fetchCars();
//             setShowForm(false); // Close the popup after submission
//         } catch (error) {
//             console.error("Error adding car:", error.response?.data || error.message);
//         }
//     };

//     return (
//         <div className="p-6">
//             <Sidebar/>
//             <h2 className="text-2xl font-bold mb-4">Car Management</h2>

//             {/* Plus Icon Button */}
//             <button
//                 onClick={() => setShowForm(true)}
//                 className="absolute top-6 right-6 bg-blue-500 text-white p-4 rounded-full shadow-lg"
//             >
//                 +
//             </button>

//             {/* Popup for Car Form */}
//             {showForm && (
//                 <div
//                     className="fixed inset-0 bg-gray-500 bg-opacity-50 flex justify-center items-center"
//                     onClick={() => setShowForm(false)}
//                 >
//                     <div
//                         className="bg-white shadow-md rounded p-6 relative"
//                         onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the form
//                     >
//             <h3 className="text-xl font-bold mb-4">Add New Car</h3>
//             <form onSubmit={handleSubmit}>
//             <input
//         type="text"
//         name="name"
//         value={newCar.name}
//         onChange={handleChange}
//         placeholder="Car Name"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <select
//         name="manufacturerId"
//         value={newCar.manufacturerId}
//         onChange={handleChange}
//         className="border p-2 rounded w-full mb-2"
//         required
//     >
//         <option value="">Select Manufacturer</option>
//         {manufacturers.map(manufacturer => (
//             <option key={manufacturer.manufacturerId} value={manufacturer.manufacturerId}>
//                 {manufacturer.name}
//             </option>
//         ))}
//     </select>
//     <input
//         type="text"
//         name="type"
//         value={newCar.type}
//         onChange={handleChange}
//         placeholder="Type"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <input
//         type="text"
//         name="capacity"
//         value={newCar.capacity}
//         onChange={handleChange}
//         placeholder="Capacity"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <input
//         type="text"
//         name="perDay"
//         value={newCar.perDay}
//         onChange={handleChange}
//         placeholder="Per Day"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <div className="flex items-center mb-2">
//         <input
//             type="checkbox"
//             name="isPopular"
//             checked={newCar.isPopular}
//             onChange={handleChange}
//             className="mr-2"
//         />
//         <label>Popular</label>
//     </div>
//     <div className="flex items-center mb-2">
//         <input
//             type="checkbox"
//             name="isRecommended"
//             checked={newCar.isRecommended}
//             onChange={handleChange}
//             className="mr-2"
//         />
//         <label>Recommended</label>
//     </div>
//     <input
//         type="text"
//         name="travelType"
//         value={newCar.travelType}
//         onChange={handleChange}
//         placeholder="Travel Type"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <input
//         type="text"
//         name="vehicleType"
//         value={newCar.vehicleType}
//         onChange={handleChange}
//         placeholder="Vehicle Type"
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <div className="flex items-center mb-2">
//         <input
//             type="checkbox"
//             name="isBooked"
//             checked={newCar.isBooked}
//             onChange={handleChange}
//             className="mr-2"
//         />
//         <label>Booked</label>
//     </div>
//     <input
//         type="file"
//         name="imageFile"
//         accept="image/*"
//         onChange={handleChange}
//         className="border p-2 rounded w-full mb-2"
//         required
//     />
//     <button
//         type="submit"
//         className="bg-blue-500 text-white p-2 rounded w-full"
//     >
//         Add Car
//     </button>
// </form>
//                     </div>
//                 </div>
//             )}

//             {/* Car List */}
//             <div className="ml-64"> {/* Adjust margin to match sidebar width */}
//     <h3 className="text-xl font-bold mb-2">Car List</h3>
//     <table className="w-full border-collapse border border-gray-200">
//         <thead>
//             <tr className="bg-gray-100">
//                 <th className="border p-2">Car Name</th>
//                 <th className="border p-2">Manufacturer</th>
//                 <th className="border p-2">Type</th>
//                 <th className="border p-2">Capacity</th>
//                 <th className="border p-2">Per Day</th>
//                 <th className="border p-2">Popular</th>
//                 <th className="border p-2">Recommended</th>
//                 <th className="border p-2">Image</th>
//             </tr>
//         </thead>
//         <tbody>
//             {cars.map(car => (
//                 <tr key={car.id} className="border">
//                     <td className="border p-2">{car.name}</td>
//                     <td className="border p-2">{manufacturers.find(m => m.manufacturerId === car.manufacturerId)?.name || "Unknown"}</td>
//                     <td className="border p-2">{car.type}</td>
//                     <td className="border p-2">{car.capacity}</td>
//                     <td className="border p-2">{car.perDay}</td>
//                     <td className="border p-2">{car.isPopular ? "✔" : "✖"}</td>
//                     <td className="border p-2">{car.isRecommended ? "✔" : "✖"}</td>
//                     <td className="border p-2">
//                         {car.imageUrl && <img src={car.imageUrl} alt="Car" className="h-16 w-24 object-cover" />}
//                     </td>
//                 </tr>
//             ))}
//         </tbody>
//     </table>
// </div>
// </div>

//     );
// }

////2025/2/try

// import { useEffect, useState } from "react";
// import axios from "axios";
// import Sidebar from './Sidebar';
// import flag from "../assets/IMG2.png";
// import {
//     FaEdit,
//     FaPlus,
//     FaTimes,
//     FaClipboardList,
//     FaChevronDown,
//     FaChevronUp
//   } from "react-icons/fa";

// export default function CarManagement() {
//     const [cars, setCars] = useState([]);
//     const [manufacturers, setManufacturers] = useState([]);
//     const [newCar, setNewCar] = useState({
//         name: "",
//         manufacturerId: "",
//         type: "",
//         capacity: "",
//         perDay: "",
//         isPopular: false,
//         isRecommended: false,
//         travelType: "",
//         vehicleType: "",
//         isBooked: false,
//         image: null
//     });
//     const [showForm, setShowForm] = useState(false);

//     useEffect(() => {
//         fetchCars();
//         fetchManufacturers();
//     }, []);

//     const fetchCars = async () => {
//         try {
//             const response = await axios.get("https://carrentalbackend.dockyardsoftware.com/api/CarDetail");
//             setCars(response.data);
//         } catch (error) {
//             console.error("Error fetching cars:", error);
//         }
//     };

//     const fetchManufacturers = async () => {
//         try {
//             const response = await axios.get("https://carrentalbackend.dockyardsoftware.com/api/Manufacturer");
//             setManufacturers(response.data);
//         } catch (error) {
//             console.error("Error fetching manufacturers:", error);
//         }
//     };

//     const handleChange = (e) => {
//         const { name, type, value, checked, files } = e.target;
//         if (type === "file") {
//             setNewCar(prevState => ({ ...prevState, image: files[0] }));
//         } else {
//             setNewCar(prevState => ({ ...prevState, [name]: type === "checkbox" ? checked : value }));
//         }
//     };

//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (!newCar.image) {
//             alert("Please select an image.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("name", newCar.name);
//         formData.append("manufacturerId", newCar.manufacturerId);
//         formData.append("type", newCar.type);
//         formData.append("capacity", newCar.capacity);
//         formData.append("perDay", newCar.perDay);
//         formData.append("isPopular", newCar.isPopular);
//         formData.append("isRecommended", newCar.isRecommended);
//         formData.append("travelType", newCar.travelType);
//         formData.append("vehicleType", newCar.vehicleType);
//         formData.append("isBooked", newCar.isBooked);
//         formData.append("imageFile", newCar.image);

//         try {
//             await axios.post("https://carrentalbackend.dockyardsoftware.com/api/CarDetail", formData, {
//                 headers: { "Content-Type": "multipart/form-data" }
//             });
//             setNewCar({
//                 name: "",
//                 manufacturerId: "",
//                 type: "",
//                 capacity: "",
//                 perDay: "",
//                 isPopular: false,
//                 isRecommended: false,
//                 travelType: "",
//                 vehicleType: "",
//                 isBooked: false,
//                 image: null
//             });
//             fetchCars();
//             setShowForm(false); // Close the popup after submission
//         } catch (error) {
//             console.error("Error adding car:", error.response?.data || error.message);
//         }
//     };

//     return (
//         <div className="flex h-screen">

//             {/* Sidebar */}
//             <Sidebar />

//             {/* Main Content */}
//             <div className="flex-1 p-6 overflow-auto">
//             <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />
//                 <h2 className="text-2xl font-bold mb-4"></h2>

//                 {/* Popup for Car Form */}
//                 {showForm && (
//     <div
//         className="fixed inset-0  bg-opacity-50 flex justify-center items-center z-50  overflow-y-auto py-10 min-h-screen bg-gray-600 bg-opacity-75"
//         onClick={() => setShowForm(false)}
//     >
//         <div className="flex items-center justify-center">
//         <div
//           className={`bg-white
//             ? "opacity-80"
//             : "bg-opacity-100"} p-8 m-5 rounded-3xl shadow-lg max-w-xl w-full relative`}
//         >
//           <div className="flex justify-end ">
//             <button

//               className="flex relative items-center justify-end cursor-pointer text-xl text-gray-600 hover:text-gray-800"
//               aria-label="Close"
//             >
//               <FaTimes />
//             </button>
//           </div>

//         <div

//             onClick={(e) => e.stopPropagation()}
//         >

//                             <h3 className="text-xl font-bold mb-4">Add New Car</h3>
//                         <form onSubmit={handleSubmit}>
//                         <input
//                     type="text"
//                     name="name"
//                     value={newCar.name}
//                     onChange={handleChange}
//                     placeholder="Car Name"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <select
//                     name="manufacturerId"
//                     value={newCar.manufacturerId}
//                     onChange={handleChange}
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 >
//                     <option value="">Select Manufacturer</option>
//                     {manufacturers.map(manufacturer => (
//                         <option key={manufacturer.manufacturerId} value={manufacturer.manufacturerId}>
//                             {manufacturer.name}
//                         </option>
//                     ))}
//                 </select>
//                 <input
//                     type="text"
//                     name="type"
//                     value={newCar.type}
//                     onChange={handleChange}
//                     placeholder="Type"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <input
//                     type="text"
//                     name="capacity"
//                     value={newCar.capacity}
//                     onChange={handleChange}
//                     placeholder="Capacity"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <input
//                     type="text"
//                     name="perDay"
//                     value={newCar.perDay}
//                     onChange={handleChange}
//                     placeholder="Per Day"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <div className="flex items-center mb-2">
//                     <input
//                         type="checkbox"
//                         name="isPopular"
//                         checked={newCar.isPopular}
//                         onChange={handleChange}
//                         className="mr-2"
//                     />
//                     <label>Popular</label>
//                 </div>
//                 <div className="flex items-center mb-2">
//                     <input
//                         type="checkbox"
//                         name="isRecommended"
//                         checked={newCar.isRecommended}
//                         onChange={handleChange}
//                         className="mr-2"
//                     />
//                     <label>Recommended</label>
//                 </div>
//                 <input
//                     type="text"
//                     name="travelType"
//                     value={newCar.travelType}
//                     onChange={handleChange}
//                     placeholder="Travel Type"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <input
//                     type="text"
//                     name="vehicleType"
//                     value={newCar.vehicleType}
//                     onChange={handleChange}
//                     placeholder="Vehicle Type"
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <div className="flex items-center mb-2">
//                     <input
//                         type="checkbox"
//                         name="isBooked"
//                         checked={newCar.isBooked}
//                         onChange={handleChange}
//                         className="mr-2"
//                     />
//                     <label>Booked</label>
//                 </div>
//                 <input
//                     type="file"
//                     name="imageFile"
//                     accept="image/*"
//                     onChange={handleChange}
//                     className="border p-2 rounded w-full mb-2"
//                     required
//                 />
//                 <button
//                     type="submit"
//                     className="bg-blue-500 text-white p-2 rounded w-full"
//                 >
//                     Add Car
//                 </button>
//             </form>
//             </div>
//                         </div>
//                     </div>
//                     </div>

//                 )}

//                 {/* Car List Table */}
//                 <div className="mt-6 relative">

//     <div
//         className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl"
//         style={{
//             backdropFilter: "blur(15px)",
//             boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
//             border: "1px solid rgba(182, 168, 168, 0.3)",
//         }}
//     >

// <div >
//     {/* Plus Icon Button (Top Right) */}
//     <button
//         title="Add New"
//         onClick={() => setShowForm(true)}
//         className="absolute top-3 right-3 bg-blue-500 hover:bg-green-600 rounded-full p-3 text-white text-lg lg:text-2xl"
//     >
//         <FaPlus />
//     </button>

//     <div className="overflow-x-auto">
//     <h3 className="text-xl font-bold mb-2">Car List</h3>

//     <table className="w-full text-sm text-left text-gray-500">
//         <thead className="text-xs text-gray-700 uppercase bg-gray-200">
//             <tr className="bg-gray-100">
//                 <th className="px-4 py-3">Car ID</th>
//                 <th className="px-4 py-3">Car Name</th>
//                 <th className="px-4 py-3">Manufacturer ID</th>
//                 <th className="px-4 py-3">Manufacturer</th>
//                 <th className="px-4 py-3">Type</th>
//                 <th className="px-4 py-3">Capacity</th>
//                 <th className="px-4 py-3">Per Day</th>
//                 <th className="px-4 py-3">Popular</th>
//                 <th className="px-4 py-3">Recommended</th>
//                 <th className="px-4 py-3">Image</th>
//                 <th className="px-4 py-3">Action</th>
//             </tr>
//         </thead>
//         <tbody>
//             {cars.map((car) => (
//                 <tr key={car.id} className="border">
//                     <td className="px-4 py-2 font-medium text-gray-900">{car.id}</td>
//                     <td className="px-4 py-2 ">{car.name}</td>
//                     <td className="px-4 py-2 ">{car.manufacturerId}</td>
//                     <td className="px-4 py-2">{manufacturers.find((m) => m.manufacturerId === car.manufacturerId)?.name || "Unknown"}</td>
//                     <td className="px-4 py-2">{car.type}</td>
//                     <td className="px-4 py-2">{car.capacity}</td>
//                     <td className="px-4 py-2">{car.perDay}</td>
//                     <td className="px-4 py-2">{car.isPopular ? "✔" : "✖"}</td>
//                     <td className="px-4 py-2">{car.isRecommended ? "✔" : "✖"}</td>
//                     {/* <td className="px-4 py-2">
//                         {car.imageUrl && <img src={car.imageUrl} alt="Car" className="h-12 w-20 object-cover rounded-md" />}
//                     </td> */}
//                   <td className="px-4 py-2">
//   {car.imagePath || car.id ? (
//     <img
//       src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${car.id}`}
//       alt="Car"
//       className="w-20 h-14 object-cover rounded"
//     />
//   ) : (
//     <span>No Image</span>
//   )}
// </td>
// <td className="px-4 py-2"></td>

//                 </tr>
//             ))}
//         </tbody>
//     </table>
// </div>

//                 </div>
//             </div>
//             </div>
//         </div>
//         </div>
//     );
// }

import { useEffect, useState } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import flag from "../assets/IMG2.png";

import {
  FaEdit,
  FaPlus,
  FaTimes,
  FaTrash,
  FaClipboardList,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

export default function CarManagement() {
  const [cars, setCars] = useState([]);
  const [manufacturers, setManufacturers] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [existingImagePath, setExistingImagePath] = useState(null);

  const carsPerPage = 5;
  // Calculate pagination
  const indexOfLastCar = currentPage * carsPerPage;
  const indexOfFirstCar = indexOfLastCar - carsPerPage;
  const currentCars = cars.slice(indexOfFirstCar, indexOfLastCar);

  // Pagination function
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [editCarId, setEditCarId] = useState(null);

  const [newCar, setNewCar] = useState({
    name: "",
    manufacturerId: "",
    type: "",
    capacity: "",
    perDay: "",
    isPopular: false,
    isRecommended: false,
    travelType: "",
    vehicleType: "",
    steering: "",
    gasoline: "",
    isBooked: false,
    image: null,
  });
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    fetchCars();
    fetchManufacturers();
  }, []);

  const fetchCars = async () => {
    try {
      const response = await axios.get(
        "https://carrentalbackend.dockyardsoftware.com/api/CarDetail"
      );
      setCars(response.data);
    } catch (error) {
      console.error("Error fetching cars:", error);
    }
  };

  const fetchManufacturers = async () => {
    try {
      const response = await axios.get(
        "https://carrentalbackend.dockyardsoftware.com/api/Manufacturer"
      );
      setManufacturers(response.data);
    } catch (error) {
      console.error("Error fetching manufacturers:", error);
    }
  };
  // const handleDelete = async (id) => {
  //     const confirmDelete = window.confirm("Are you sure you want to delete this car?");
  //     if (!confirmDelete) return;

  //     try {
  //         await axios.delete(`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/${id}`);
  //         alert("Car deleted successfully.");
  //         fetchCars(); // correct function to refresh car list
  //     } catch (error) {
  //         console.error("Delete failed:", error);
  //         alert("Failed to delete car.");
  //     }
  // };
  const handleDelete = async (id) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this car?"
    );
    if (!confirmDelete) return;

    try {
      await axios.delete(
        `https://carrentalbackend.dockyardsoftware.com/api/CarDetail/${id}`
      );
      alert("Car deleted successfully.");
      fetchCars(); // Refresh car list
    } catch (error) {
      console.error("Delete failed:", error);

      // Check if backend sent a specific error message
      if (error.response && error.response.data) {
        const errorMessage =
          typeof error.response.data === "string"
            ? error.response.data
            : error.response.data.error || "Failed to delete car.";

        alert(`Cannot delete: ${errorMessage}`);
      } else {
        alert("An unexpected error occurred while deleting the car.");
      }
    }
  };

  const handleChange = (e) => {
    const { name, type, value, checked, files } = e.target;
    if (type === "file") {
      setNewCar((prevState) => ({ ...prevState, image: files[0] }));
    } else {
      setNewCar((prevState) => ({
        ...prevState,
        [name]: type === "checkbox" ? checked : value,
      }));
    }
  };

  const handleEdit = async (carId) => {
    try {
      const response = await axios.get(
        `https://carrentalbackend.dockyardsoftware.com/api/CarDetail/${carId}`
      );
      const car = response.data;

      setNewCar({
        name: car.name,
        manufacturerId: car.manufacturerId,
        type: car.type,
        capacity: car.capacity,
        perDay: car.perDay,
        isPopular: car.isPopular,
        isRecommended: car.isRecommended,
        travelType: car.travelType,
        vehicleType: car.vehicleType,
        isBooked: car.isBooked,
        gasoline: car.gasoline,
        steering: car.steering,
        image: null, // image not included on edit, unless updated
      });

      setExistingImagePath(
        `https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${carId}`
      );
      setEditCarId(carId);
      setEditMode(true);
      setShowForm(true);
    } catch (error) {
      console.error("Error fetching car details:", error);
    }
  };

  const initialCarState = {
    name: "",
    manufacturerId: "",
    type: "",
    capacity: "",
    perDay: "",
    isPopular: false,
    isRecommended: false,
    travelType: "",
    vehicleType: "",
    gasoline: "",
    steering: "",
    isBooked: false,
    image: null,
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formData = new FormData();
    formData.append("name", newCar.name);
    formData.append("manufacturerId", newCar.manufacturerId);
    formData.append("type", newCar.type);
    formData.append("capacity", newCar.capacity);
    formData.append("perDay", newCar.perDay);
    formData.append("isPopular", newCar.isPopular);
    formData.append("isRecommended", newCar.isRecommended);
    formData.append("travelType", newCar.travelType);
    formData.append("vehicleType", newCar.vehicleType);
    formData.append("steering", newCar.steering);
    formData.append("gasoline", newCar.gasoline);
    formData.append("isBooked", newCar.isBooked);
    if (newCar.image) formData.append("imageFile", newCar.image);

    try {
      if (editMode) {
        await axios.put(
          `https://carrentalbackend.dockyardsoftware.com/api/CarDetail/${editCarId}`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      } else {
        await axios.post(
          "https://carrentalbackend.dockyardsoftware.com/api/CarDetail",
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" },
          }
        );
      }

      setNewCar({ ...initialCarState }); // reset
      setEditMode(false);
      setEditCarId(null);
      setShowForm(false);
      fetchCars();
    } catch (error) {
      console.error("Error saving car:", error.response?.data || error.message);
    }
  };

  return (
    <div className="flex h-screen">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <div className="flex-1 p-6 overflow-auto">
        <img src={flag} alt="Logo" className="h-10 w-auto mr-2" />
        <h2 className="text-2xl font-bold mb-4"></h2>

        {/* Popup for Car Form */}
        {showForm && (
          <div
            className="fixed inset-0  bg-opacity-50 flex justify-center items-center z-50  overflow-y-auto py-10 min-h-screen bg-gray-600 bg-opacity-75 "
            onClick={() => setShowForm(false)}
          >
            <div className="flex items-center justify-center mt-60">
              <div
                className={`bg-white 
            ? "opacity-80"
            : "bg-opacity-100"} p-8 m-5 rounded-3xl shadow-lg max-w-xl w-full relative `}
              >
                <div className="flex justify-end ">
                  <button
                    className="flex relative items-center justify-end cursor-pointer text-xl text-gray-600 hover:text-gray-800"
                    aria-label="Close"
                  >
                    <FaTimes />
                  </button>
                </div>

                <div onClick={(e) => e.stopPropagation()}>
                  {/* <h3 className="text-xl font-bold mb-4">Add New Car</h3> */}
                  <h3 className="text-xl font-bold mb-4">
                    {editMode ? "Edit Car" : "Add New Car"}
                  </h3>
                  <form onSubmit={handleSubmit}>
                    <input
                      type="text"
                      name="name"
                      value={newCar.name}
                      onChange={handleChange}
                      placeholder="Car Name"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <select
                      name="manufacturerId"
                      value={newCar.manufacturerId}
                      onChange={handleChange}
                      className="border p-2 rounded w-full mb-2"
                      required
                    >
                      <option value="">Select Manufacturer</option>
                      {manufacturers.map((manufacturer) => (
                        <option
                          key={manufacturer.manufacturerId}
                          value={manufacturer.manufacturerId}
                        >
                          {manufacturer.name}
                        </option>
                      ))}
                    </select>
                    <input
                      type="text"
                      name="type"
                      value={newCar.type}
                      onChange={handleChange}
                      placeholder="Type"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <input
                      type="text"
                      name="steering"
                      value={newCar.steering}
                      onChange={handleChange}
                      placeholder="steering"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <input
                      type="text"
                      name="gasoline"
                      value={newCar.gasoline}
                      onChange={handleChange}
                      placeholder="gasoline"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <input
                      type="text"
                      name="capacity"
                      value={newCar.capacity}
                      onChange={handleChange}
                      placeholder="Capacity"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <input
                      type="text"
                      name="perDay"
                      value={newCar.perDay}
                      onChange={handleChange}
                      placeholder="Per Day"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        name="isPopular"
                        checked={newCar.isPopular}
                        onChange={handleChange}
                        className="mr-2"
                      />
                      <label>Popular</label>
                    </div>
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        name="isRecommended"
                        checked={newCar.isRecommended}
                        onChange={handleChange}
                        className="mr-2"
                      />
                      <label>Recommended</label>
                    </div>
                    <input
                      type="text"
                      name="travelType"
                      value={newCar.travelType}
                      onChange={handleChange}
                      placeholder="Travel Type"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <input
                      type="text"
                      name="vehicleType"
                      value={newCar.vehicleType}
                      onChange={handleChange}
                      placeholder="Vehicle Type"
                      className="border p-2 rounded w-full mb-2"
                      required
                    />
                    <div className="flex items-center mb-2">
                      <input
                        type="checkbox"
                        name="isBooked"
                        checked={newCar.isBooked}
                        onChange={handleChange}
                        className="mr-2"
                      />
                      <label>Booked</label>
                    </div>
                    {existingImagePath && (
                      <div className="mb-2">
                        <label className="block text-sm font-medium text-gray-700 mb-1">
                          Current Image:
                        </label>
                        <img
                          src={existingImagePath}
                          alt="Current Car"
                          className="w-40 h-28 object-contain rounded border"
                        />
                      </div>
                    )}

                    <div className="mb-2">
                      <label className="block text-sm font-medium text-gray-700 mb-1">
                        Upload Car Image:
                      </label>
                      <input
                        type="file"
                        name="image"
                        accept="image/*"
                        onChange={handleChange}
                        className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4
               file:rounded-full file:border-0 file:text-sm file:font-semibold
               file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                      />
                    </div>

                    {/* <button 
                    type="submit" 
                    className="bg-blue-500 text-white p-2 rounded w-full"
                >
                    Add Car
                </button> */}
                    <button
                      type="submit"
                      className="bg-blue-500 text-white p-2 rounded w-full"
                    >
                      {editMode ? "Update Car" : "Add Car"}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* Car List Table */}
        <div className="mt-6 relative">
          <div
            className="relative bg-white lg:w-[90%] w-[100%] lg:mx-3 lg:px-10 lg:py-10 p-5 lg:rounded-tl-[3rem] rounded-lg shadow-xl"
            style={{
              backdropFilter: "blur(15px)",
              boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
              border: "1px solid rgba(182, 168, 168, 0.3)",
            }}
          >
            <div>
              {/* Plus Icon Button (Top Right) */}
              <button
                title="Add New"
                onClick={() => setShowForm(true)}
                className="absolute top-3 right-3 bg-blue-500 hover:bg-green-600 rounded-full p-3 text-white text-lg lg:text-2xl"
              >
                <FaPlus />
              </button>

              <div className="overflow-x-auto">
                <h3 className="text-xl font-bold mb-2">Car List</h3>

                <table className="w-full text-sm text-left text-gray-500">
                  <thead className="text-xs text-gray-700   bg-gray-200">
                    <tr className="bg-gray-100">
                      <th className="px-4 py-3 text-center">Car ID</th>
                      <th className="px-4 py-3 text-left">Car Name</th>
                      <th className="px-4 py-3 text-center">Manufacturer ID</th>
                      <th className="px-4 py-3 text-left">Manufacturer</th>
                      <th className="px-4 py-3 text-left">Type</th>
                      <th className="px-4 py-3 text-center">Capacity</th>
                      <th className="px-4 py-3 text-left">Steering</th>
                      <th className="px-4 py-3 text-center">Gasoline</th>
                      <th className="px-4 py-3 text-right">Per Day</th>
                      <th className="px-4 py-3 text-center">Popular</th>
                      <th className="px-4 py-3 text-center">Recommended</th>
                      <th className="px-4 py-3 text-center">Image</th>
                      <th className="px-4 py-3 text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* {cars.map((car) => ( */}
                    {currentCars.map((car, index) => (
                      <tr key={car.carId} className="border-t">
                        {/* <td className="px-4 py-2">{indexOfFirstCar + index + 1}</td> */}
                        <td className="px-4 py-2 font-medium text-gray-900 text-center">
                          {car.id}
                        </td>
                        <td className="px-4 py-2 text-left">{car.name}</td>
                        <td className="px-4 py-2 text-center">{car.manufacturerId}</td>
                        <td className="px-4 py-2 text-left">
                          {manufacturers.find(
                            (m) => m.manufacturerId === car.manufacturerId
                          )?.name || "Unknown"}
                        </td>
                        <td className="px-4 py-2 text-left">{car.type}</td>
                        <td className="px-4 py-2 text-center">{car.capacity}</td>
                        <td className="px-4 py-2 text-left">{car.steering}</td>
                        <td className="px-4 py-2 text-center">{car.gasoline}</td>
                        <td className="px-4 py-2 text-right">{Number(car.perDay).toFixed(2)}</td>

                        <td className="px-4 py-2 text-center">
                          {car.isPopular ? "✔" : "✖"}
                        </td>
                        <td className="px-4 py-2 text-center">
                          {car.isRecommended ? "✔" : "✖"}
                        </td>
                        {/* <td className="px-4 py-2">
                        {car.imageUrl && <img src={car.imageUrl} alt="Car" className="h-12 w-20 object-cover rounded-md" />}
                    </td> */}
                        <td className="px-4 py-2">
                          {car.imagePath || car.id ? (
                            <img
                              src={`https://carrentalbackend.dockyardsoftware.com/api/CarDetail/GetImage/${car.id}`}
                              alt="Car"
                              className="w-24 h-16 object-contain rounded bg-gray-100"
                            />
                          ) : (
                            <span>No Image</span>
                          )}
                        </td>

                        <td className="px-4 py-2 text-center space-x-2">
                          <button
                            onClick={() => handleEdit(car.id)}
                            className="text-blue-500 hover:text-blue-700"
                          >
                            <FaEdit />
                          </button>
                          <button
                            onClick={() => handleDelete(car.id)}
                            className="text-red-500 hover:text-red-700"
                          >
                            <FaTrash />
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
              <div className="flex justify-between items-center mt-4 px-4">
                <span className="text-xs text-gray-600">
                  {indexOfFirstCar + 1} to{" "}
                  {Math.min(indexOfLastCar, cars.length)} of {cars.length}{" "}
                  records
                </span>
                <nav className="flex items-center space-x-1">
                  <button
                    onClick={() => paginate(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="px-2 py-1 text-xs rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                  >
                    &lt;
                  </button>

                  {Array.from(
                    { length: Math.ceil(cars.length / carsPerPage) },
                    (_, i) => {
                      if (
                        i + 1 === currentPage ||
                        i + 1 === 1 ||
                        i + 1 === Math.ceil(cars.length / carsPerPage) ||
                        Math.abs(i + 1 - currentPage) <= 1
                      ) {
                        return (
                          <button
                            key={i}
                            onClick={() => paginate(i + 1)}
                            className={`px-2 py-1 text-xs rounded border ${
                              currentPage === i + 1
                                ? "bg-blue-500 text-white"
                                : "bg-gray-100 hover:bg-gray-200"
                            }`}
                          >
                            {i + 1}
                          </button>
                        );
                      } else if (Math.abs(i + 1 - currentPage) === 2) {
                        return (
                          <span key={i} className="px-1 text-gray-500 text-xs">
                            ...
                          </span>
                        );
                      }
                      return null;
                    }
                  )}

                  <button
                    onClick={() => paginate(currentPage + 1)}
                    disabled={
                      currentPage === Math.ceil(cars.length / carsPerPage)
                    }
                    className="px-2 py-1 text-xs rounded border bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
                  >
                    &gt;
                  </button>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
